import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { getLinkLtik } from 'constants/LTIData';

import CourseProgress from 'components/UI/CourseProgress/CourseProgress';

import classes from './CoevaluationIconProgress.module.css';

const url = window.location.pathname.split('/');

const CoevaluationIconProgress = props => {
  const { t } = useTranslation(['course']);
  const [activityState, setActivityState] = useState(
    'without_starting'
  );
  const [coevalState, setCoevalState] = useState('without_starting');

  useEffect(() => {
    {
      props.userTrack.map(track => {
        track.id_media === props.data.idVideo &&
          (track.media_eval === 2
            ? setActivityState('finished')
            : track.media_eval === 1
            ? setActivityState('started')
            : track.media_eval === 0
            ? setActivityState('without_starting')
            : '');
      });
    }
    {
      props.userTrack.map(track => {
        track.id_media === props.data.idVideo &&
          (track.media_coeval >= 3
            ? setCoevalState('finished')
            : track.media_coeval >= 1
            ? setCoevalState('started')
            : track.media_coeval === 0
            ? setCoevalState('without_starting')
            : '');
      });
    }
  }, []);

  return (
    <>
      {props.accessCourse &&
        props.data.evaluation.coevaluation === 1 && (
          <>
            <>
              <Link
                to={
                  getLinkLtik()
                    ? `/ac/${props.data.idCourse}/${
                        props.data.idVideo
                      }/?ltik=${getLinkLtik()}`
                    : url[2] === 'a'
                    ? `/a/ac/${props.data.idCourse}/${props.data.idVideo}`
                    : url[2] === 'course'
                    ? `/course/ac/${props.data.idCourse}/${props.data.idVideo}`
                    : `/ac/${props.data.idCourse}/${props.data.idVideo}`
                }
                className={`${classes.productLesson} ${
                  !props.accessCourse
                    ? classes.productLessonDisabled
                    : ''
                }`}
              >
                <CourseProgress
                  activityState={activityState}
                  icon="activity"
                />
                <p className={classes.productContentItemText}>
                  {t('activity')}
                </p>
              </Link>
            </>
            <>
              <Link
                to={
                  getLinkLtik()
                    ? `/coe/${props.data.idCourse}/${
                        props.data.idVideo
                      }/?ltik=${getLinkLtik()}`
                    : url[2] === 'a'
                    ? `/a/coe/${props.data.idCourse}/${props.data.idVideo}`
                    : url[2] === 'course'
                    ? `/course/coe/${props.data.idCourse}/${props.data.idVideo}`
                    : `/coe/${props.data.idCourse}/${props.data.idVideo}`
                }
                className={`${classes.productLesson} ${
                  !props.accessCourse
                    ? classes.productLessonDisabled
                    : ''
                }`}
              >
                <CourseProgress
                  activityState={coevalState}
                  icon="coeval"
                />
                <p className={classes.productContentItemText}>
                  {t('peer_evaluation')}
                </p>
              </Link>
            </>
          </>
        )}
    </>
  );
};

CoevaluationIconProgress.propTypes = {
  // eslint-disable-next-line react/require-default-props
  data: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  accessCourse: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  userTrack: PropTypes.object
};

export default CoevaluationIconProgress;
